import { render, staticRenderFns } from "./storeStockRecord.vue?vue&type=template&id=549fec82"
import script from "./storeStockRecord.vue?vue&type=script&lang=js"
export * from "./storeStockRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports